<template>
  <div class="dropdown-container" @click="toggleDropdown">
    <div class="dropdown-display">
      <img :src="selectedOption.imgUrl" alt="Selected" class="w-[80px]" />
    </div>
    <div v-if="isOpen" class="dropdown-menu">
      <div v-for="option in options" :key="option.value" class="dropdown-item" @click.stop="selectOption(option)">
        <img :src="option.imgUrl" :alt="option.text" class="w-[80px] max-h-[80px]"  />
        <!--<span>{{ option.text }}</span>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectImage',
  props: {
    options: {
      type: Array,
      required: true
    },
    modelValue: {  
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isOpen: false,
      selectedOption: {}
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newValue) {
        this.selectedOption = this.options.find(option => option.value === newValue) || this.options[0];
      }
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        document.addEventListener('click', this.handleOutsideClick);
      } else {
        document.removeEventListener('click', this.handleOutsideClick);
      }
    },
    selectOption(option) {
      this.selectedOption = option;
      this.closeDropdown();
      this.$emit('update:modelValue', option.value);
    },
    handleOutsideClick(e) {
      if (!this.$el.contains(e.target)) {
        this.closeDropdown();
      }
    },
    closeDropdown() {
      this.isOpen = false;
      document.removeEventListener('click', this.handleOutsideClick);
    }
  },
  beforeUnmount() {
    // Limpa o listener quando o componente for destruído
    document.removeEventListener('click', this.handleOutsideClick);
  }
};
</script>


<style scoped>
.dropdown-container {
  position: relative;
  width: 100%;
}

.dropdown-display {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.dropdown-menu {
  position: absolute;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: white;
  z-index: 1000;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}

</style>
